import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import StatusBadge from './StatusBadge';
import { formatISOStringToReadable } from '../../../../utils/dateUtils';
import ReactDOM from "react-dom";

const BookingRow = ({ booking, onShowDetails, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  const handleActionClick = (action) => {
    setShowDropdown(false);
    switch(action) {
      case 'view':
        onShowDetails(booking);
        break;
      case 'edit':
        onEdit(booking);
        break;
      case 'delete':
        onDelete(booking);
        break;
      default:
        break;
    }
  };

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const handleDropdownBlur = () => {
    setTimeout(() => setShowDropdown(false), 150);
  };

  useEffect(() => {
    if (showDropdown && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
    }
  }, [showDropdown]);

  return (
    <tr className="table-row">
      <td className="row-item">{booking.bookingId}</td>
      <td className="row-item" style={{ fontWeight: 600 }}>{booking.customer.customerName}</td>
      <td className="row-item">{booking.customer.phoneNumber}</td>
      <td className="row-item">
        <div className="date-info">
          <div className="date">{formatISOStringToReadable(booking.bookingAt)}</div>
        </div>
      </td>
      <td>
        <StatusBadge status={booking.status} />
      </td>
      <td className="actions-cell">
        <div className="actions-dropdown">
          <button 
            ref={buttonRef}
            className="actions-trigger"
            onClick={handleDropdownToggle}
            onBlur={handleDropdownBlur}
            aria-label={t('admin.bookings.actions.more_actions')}
          >
            ⋮
          </button>
          {showDropdown && ReactDOM.createPortal(
            <div 
              className="actions-menu"
              style={{
                position: "absolute",
                top: menuPos.top,
                right: window.innerWidth - (buttonRef.current.getBoundingClientRect().right + window.scrollX),
                minWidth: "max-content"
              }}
            >
              <button 
                className="actions-item"
                onClick={() => handleActionClick('view')}
              >
                {t('admin.bookings.actions.view_details')}
              </button>
              <button 
                className="actions-item"
                onClick={() => handleActionClick('edit')}
              >
                {t('admin.bookings.actions.edit')}
              </button>
              <button 
                className="actions-item delete-option"
                onClick={() => handleActionClick('delete')}
              >
                {t('admin.bookings.actions.delete')}
              </button>
            </div>,
            document.body
          )}
        </div>
      </td>
    </tr>
  );
};

export default BookingRow;
